import { Box } from "./box";
import styled from "styled-components";

export const Text = styled(Box)({});

Text.defaultProps = {
  p: [1, 2, 3]
};
